var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-img',{staticClass:"make-logo",class:_vm.iconClass,attrs:{"src":_vm.getLogoForMake,"alt":_vm.make.name}}),_c('span',{staticClass:"make-name"},[_vm._v(" "+_vm._s(_vm.make.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }